import { render, staticRenderFns } from "./rating-scale.vue?vue&type=template&id=c0d9810a"
import script from "./rating-scale.vue?vue&type=script&lang=js"
export * from "./rating-scale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports